// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3nrs6","icon":"styles_icon__QWP16"};